var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplititIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#ECF1F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3928_42249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 16,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6667,
    y: 10,
    width: 15.2,
    height: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3928_42249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 28.0471C13.3653 28.3403 13.751 28.618 14.1676 28.8572C18.2493 31.2105 23.465 29.814 25.8183 25.7324C28.1716 21.6508 26.775 16.4351 22.6935 14.0818C22.2768 13.8426 21.8447 13.642 21.4127 13.48L13.0026 28.0471Z",
    fill: "#642F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6331 11.9524C25.2704 11.6592 24.8846 11.3815 24.4679 11.1423C20.3864 8.78897 15.1706 10.1932 12.8096 14.2671C10.4564 18.3487 11.8529 23.5644 15.9345 25.9177C16.3511 26.1569 16.7832 26.3575 17.2153 26.5195L25.6331 11.9524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 28.0471C13.3653 28.3403 13.751 28.618 14.1676 28.8572C18.2493 31.2105 23.465 29.814 25.8183 25.7324C28.1716 21.6508 26.775 16.4351 22.6935 14.0818C22.2768 13.8426 21.8447 13.642 21.4127 13.48L13.0026 28.0471Z",
    fill: "#642F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6331 11.9524C25.2704 11.6592 24.8846 11.3815 24.4679 11.1423C20.3864 8.78897 15.1706 10.1932 12.8096 14.2671C10.4564 18.3487 11.8529 23.5644 15.9345 25.9177C16.3511 26.1569 16.7832 26.3575 17.2153 26.5195L25.6331 11.9524Z",
    fill: "#A77BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4189 29.9988C16.9684 29.9988 15.5025 29.6284 14.1599 28.8569C13.7433 28.6177 13.3575 28.3477 12.9948 28.0468L14.7154 25.0762C15.0935 25.3926 15.4947 25.678 15.9345 25.925C16.3511 26.1642 16.7832 26.3647 17.2153 26.5268L23.9124 14.9302C25.8799 16.5813 26.96 18.9963 26.96 21.4807C26.96 22.9236 26.5897 24.3895 25.8181 25.7398C24.2364 28.4711 21.3662 29.9988 18.4189 29.9988H18.4189Z",
    fill: "#642F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2152 26.5265C16.7754 26.3645 16.351 26.1639 15.9344 25.9247C15.4946 25.6701 15.0934 25.3846 14.7153 25.076L21.4125 13.4717C21.8523 13.6336 22.2767 13.8343 22.6933 14.0735C23.1331 14.3281 23.5343 14.6136 23.9124 14.9222L17.2152 26.5265Z",
    fill: "#A77BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2152 26.5265C16.7754 26.3645 16.351 26.1639 15.9344 25.9247C15.4946 25.6701 15.0934 25.3846 14.7153 25.076L21.4125 13.4717C21.8523 13.6336 22.2767 13.8343 22.6933 14.0735C23.1331 14.3281 23.5343 14.6136 23.9124 14.9222L17.2152 26.5265Z",
    fill: "#642F6C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplititIcon);
export default __webpack_public_path__ + "static/media/SplititIcon.c9da739cf5699b1417f3fac699263c0e.svg";
export { ForwardRef as ReactComponent };